// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6dc39f21","825":"9001597e"}[chunkId] + ".chunk.js";
};